/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'src/makeStyles';

import { Collapse } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { boxShadows, colors } from '../../constants/styleConstants';
import ListCard from '../ListCard';

const useStyles = makeStyles()(theme => ({
  root: {
    padding: '0 12px',
    border: `solid 1px ${colors.border.grey1}`,
    marginBottom: theme.spacing(2),
  },
  contentWrapper: {
    display: 'flex',
  },
  expanded: {
    paddingTop: 5,
    paddingBottom: 5,
    boxShadow: boxShadows.expandedCard,
  },
  expandIcon: {
    marginTop: 12,
    cursor: 'pointer',
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
    color: colors.blueChip,
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  content: {
    margin: 12,
  },
}));

const ExpandedCard = ({ content, collapsedContent, contentClassName }) => {
  const { classes, cx } = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <ListCard
      className={cx(classes.root, {
        [classes.expanded]: expanded,
      })}
    >
      <div className={classes.contentWrapper} onClick={handleExpandClick}>
        <ExpandMoreIcon
          className={cx(classes.expandIcon, {
            [classes.expandOpen]: expanded,
          })}
        />
        <div className={cx(classes.content, contentClassName)}>{content}</div>
      </div>
      <Collapse in={expanded} timeout="auto" mountOnEnter unmountOnExit>
        {collapsedContent}
      </Collapse>
    </ListCard>
  );
};

ExpandedCard.propTypes = {
  content: PropTypes.object,
  collapsedContent: PropTypes.object,
};

export default ExpandedCard;
